export {
  Activity, AlertTriangle, AlignLeft, ArrowDown, ArrowLeft, ArrowRight, AtSign,
  Banknote, BarChart3, BedDouble, Bell, Bike, Bookmark, BookOpen, Bot, Building2, Bus,
  CalendarDays, Calendar, Camera, Car, Check, CheckCheck, CheckCircle2,
  Cloud, CloudDrizzle, CloudFog, CloudLightning, CloudRain, CloudSnow, CloudSun,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Circle, CircleDashed, Clock,
  Coffee, Compass, Copy, CreditCard, DollarSign, Download, Eye, EyeOff, ExternalLink,
  FileText, Footprints, Fuel, Gift, Globe, GripVertical, Hash, HelpCircle, Hotel,
  Gauge, Image, Info, KeyRound, Landmark, Languages, LayoutGrid, Lightbulb, List,
  ListChecks, Lock, LocateFixed, LogIn, LogOut, Luggage, Mail, Map, MapPin, Menu, Minus, Moon, MoreHorizontal,
  Navigation, Package, Paperclip, Pencil, Phone, Pill, Plane, Plug, Plus,
  Droplets, Syringe, Stamp, ShieldAlert, BookUser,
  PanelLeftClose, PanelLeftOpen,
  RefreshCw, Redo2, Route, Search, Send, Settings, Share2, Ship, ShieldCheck, ShieldOff,
  Mountain, Waves,
  Shirt, ShoppingBag, SlidersHorizontal, Sparkles, SprayCan, SquareParking, Star, Sun, Tag, Target, Ticket, Train, Trash2,
  TreePine, TrendingUp, Undo2, Upload, User, UserRound, Users, Utensils, Wallet, Wind, X, Zap,
  Croissant, Soup, Cookie, ChefHat, ShoppingBasket, ShoppingCart, UtensilsCrossed,
  BookImage, Type, AlignCenter, AlignRight, ArrowLeftRight,
} from 'lucide-react';
export type { LucideIcon } from 'lucide-react';

import { type LucideIcon } from 'lucide-react';

export function Icon({
  as: Component,
  size = 16,
  strokeWidth = 1.75,
  className,
  ...rest
}: {
  as: LucideIcon | React.ElementType;
  size?: number;
  strokeWidth?: number;
  className?: string;
} & React.SVGProps<SVGSVGElement>) {
  const C = Component as React.ElementType;
  return <C size={size} strokeWidth={strokeWidth} className={className} {...rest} />;
}
